import apiClient from "./client";
import type { DisasterIdParam, DisasterSummaryResponse } from "../types/disaster";

export const getDisasterSummary = async (
  disasterId: DisasterIdParam
): Promise<DisasterSummaryResponse> => {
  const { data } = await apiClient.get<DisasterSummaryResponse>(
    `/disaster-summary/${disasterId}`
  );
  return data;
};
